"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _responsive = require("../../responsive");

var _utils = require("../../utils");

var _constants = require("../constants");

var _interfaces = require("../interfaces");

var _DefaultTabBar = _interopRequireDefault(require("./default/DefaultTabBar"));

var _core = require("@emotion/core");

var _excluded = ["tabs", "colorScheme", "shouldActivateManually"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var TabBarWithoutDocs = function TabBarWithoutDocs(_ref) {
  var tabs = _ref.tabs,
      _ref$colorScheme = _ref.colorScheme,
      colorScheme = _ref$colorScheme === void 0 ? _constants.defaultProps.colorScheme : _ref$colorScheme,
      _ref$shouldActivateMa = _ref.shouldActivateManually,
      shouldActivateManually = _ref$shouldActivateMa === void 0 ? _constants.defaultProps.shouldActivateManually : _ref$shouldActivateMa,
      forwardedProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  // Convert all tab entries into { label, value } format
  var tabConfigs = tabs.map(function (tab) {
    return typeof tab === 'string' ? {
      label: tab,
      value: tab
    } : tab;
  });

  var props = _objectSpread({
    tabs: tabConfigs,
    colorScheme: colorScheme,
    shouldActivateManually: shouldActivateManually
  }, forwardedProps);

  if (!(0, _utils.envIsProduction)()) {
    var duplicateValues = tabConfigs.filter(function (first, index) {
      return (// If the index of a tab which has this value isn't the same as this tab's index,
        // then two different tabs have the same value
        tabConfigs.findIndex(function (second) {
          return second.value === first.value;
        }) !== index
      );
    }).map(function (tab) {
      return tab.value;
    });
    var uniqueDuplicates = (0, _toConsumableArray2.default)(new Set(duplicateValues));

    if (uniqueDuplicates.length > 0) {
      console.warn('Tabs: Each tab must have a unique `value`. Check the Tabs component with data-test-flagged="unique-tab-values". The following values were used more than once:', uniqueDuplicates.map(function (value) {
        return "\"".concat(value, "\"");
      }).join(', '));
      props['dataTestFlagged'] = 'unique-tab-values';
    }
  }

  var _useHighZoomLevel = (0, _responsive.useHighZoomLevel)({
    checkOnlyWidth: true
  }),
      isInHighZoomLevel = _useHighZoomLevel.isInHighZoomLevel;

  return (0, _core.jsx)(_DefaultTabBar.default, (0, _extends2.default)({}, props, {
    shouldWrap: isInHighZoomLevel || false
  }));
};

var TabBarWithDocs = (0, _stencilReactDesc.describe)(TabBarWithoutDocs).description('Navigational UI for switching between panes of content.');
TabBarWithDocs.defaultProps = _objectSpread({}, _constants.defaultProps);
TabBarWithDocs.propTypes = {
  tabs: _stencilReactDesc.PropTypes.oneOfType([_stencilReactDesc.PropTypes.arrayOf(_stencilReactDesc.PropTypes.shape({
    label: _stencilReactDesc.PropTypes.oneOfType([_stencilReactDesc.PropTypes.string, _stencilReactDesc.PropTypes.node]),
    value: _stencilReactDesc.PropTypes.oneOfType([_stencilReactDesc.PropTypes.string, _stencilReactDesc.PropTypes.number]),
    href: _stencilReactDesc.PropTypes.string,
    triggerProps: _stencilReactDesc.PropTypes.object
  })), _stencilReactDesc.PropTypes.arrayOf(_stencilReactDesc.PropTypes.string)]).isRequired.description('Array of tab configurations or tab labels.'),
  selectedTab: _stencilReactDesc.PropTypes.oneOfType([_stencilReactDesc.PropTypes.string, _stencilReactDesc.PropTypes.number]).isRequired.description('The `value` of the currently selected tab.'),
  onTabSelect: _stencilReactDesc.PropTypes.func.isRequired.description('Callback called when the user selects a tab.').format('(value: string | number) => void'),
  shouldActivateManually: _stencilReactDesc.PropTypes.bool.description('Determines whether tabs need to be activated manually using the keyboard.'),
  tabGroup: _stencilReactDesc.PropTypes.oneOfType([_stencilReactDesc.PropTypes.string, _stencilReactDesc.PropTypes.number]).isRequired.description('An identifier for this set of tabs which should be unique for each set on the same page. The same tabGroup should be passed to the TabSwitcher or TabPanels for these tabs.'),
  colorScheme: _stencilReactDesc.PropTypes.oneOf(Object.values(_interfaces.TabsColorScheme)).description('Selects a predefined color scheme to use for the component.'),
  'aria-label': _stencilReactDesc.PropTypes.string.description("Sets the 'aria-label' attribute for the entire component.")
};
var TabBar = (0, _utils.withTestAttributes)({})(TabBarWithDocs);
TabBar.displayName = 'TabBar';
var _default = TabBar;
exports.default = _default;